// Lib
import ntc from './ntc';

// Utils
import { getColorDefaultHexValue } from './colorHelper';

const customColorNameMapping = {
    'Double Colonial White': 'Double Colonial',
    'Double Spanish White': 'Double Spanish',
    'International Klein Blue': 'International Klein',
    'Macaroni and Cheese': 'Macaroni & Cheese',
    "Purple Mountain's Majesty": 'Purple Mountain',
    'Quarter Spanish White': 'Quarter Spanish',
    'School bus Yellow': 'School Bus Yellow',
    'Beauty Bush': 'Beauty Blush',
};

export const getColorName = (color) => {
    const colorHex = getColorDefaultHexValue(color);

    if (!colorHex) return null;

    // eslint-disable-next-line no-unused-vars
    const [_, colorName] = ntc.name(colorHex);

    const customColorName = customColorNameMapping[colorName];

    return customColorName || colorName;
};
